<template>
  <div
    class="modal-background"
    @click="$store.state.confirm.display = false"
    @keyup.esc="$store.state.confirm.display = false"
    v-if="display"
  >
    <div
      class="modal position-center"
      @click.stop
    >
      <div class="titlebar">{{ $store.state.confirm.title }}</div>
      <span class="close printhide" @click="$store.state.confirm.display = false">
        <slot name="close"><awesomeIcon icon="times" /></slot>
      </span>
      <p v-html="$store.state.confirm.text" />
      <div
        class="buttons"
        :style="$store.state.confirm.alert ? 'justify-content: center;' : ''"
      >
        <button
          @click="callback(true)"
          ref="confirmButton"
          :style="$store.state.confirm.alert ? 'width: auto;' : ''"
        >
          <awesomeIcon icon="check"/> {{ $store.state.confirm.confirmText }}
        </button>
        <button class="tertiary" @click="callback(false)" v-if="!$store.state.confirm.alert">
          <awesomeIcon icon="times"/> {{ $store.state.confirm.cancelText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmModal',
  computed: {
    display() {
      return this.$store.state.confirm.display;
    },
  },
  watch: {
    display(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.$refs.confirmButton.focus();
        });
      }
    },
  },
  methods: {
    callback(confirmed) {
      this.$store.state.confirm.display = false;
      this.$store.state.confirm.cb(confirmed);
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  width: 300px;
  border-radius: $br;
  @media screen {
    background-color: #efecf3;
  }
  position: fixed;
  p {
    padding: 15px;
    margin: 0;
  }
  .buttons {
    display: flex;
    justify-content: space-between;
    user-select: none;
    margin: 0 15px 15px;
    button {
      width: 48%;
      white-space: nowrap;
      &:focus {
        box-shadow: 0 0 0 4px rgba(#000, 0.2);
      }
      .tertiary{
        svg {
          padding-bottom: 1px;
        }
      }
    }
  }
  &.position-center {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .viewport {
      overflow: auto;
      padding: 20px;
      height: 700px;
    }
  }
  .titlebar {
    padding: 10px 20px;
    color: #fff;
    background-color: $color-background;
    border-radius: $br $br 0 0;
    min-height: 16px;
    font-weight: bold;
  }
  .close {
    cursor: pointer;
    top: 0px;
    right: 0px;
    position: absolute;
    height: 37px;
    padding-right: 20px;
    line-height: 37px;
    text-align: center;
    color: white;
  }
}
.modal-background {
  position: fixed;
  background: #0006;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
}
</style>
